// extracted by mini-css-extract-plugin
export var button = "_dl-7";
export var buttonRow = "_dl-6";
export var fadeIn = "_dl-1";
export var gradient = "_dl-0";
export var panel = "_dl-2";
export var panelIn = "_dl-3";
export var subtitle = "_dl-5";
export var title = "_dl-4";